import { useQuery } from '@tanstack/react-query';
import { ContactName, getUserContacts } from '@uplift/api';
import { useCurrentuser } from '@uplift/contexts';
import { PhoneVerificationModal } from '@uplift/ui-v2';
import React from 'react';
import { useHistory, useLocation } from 'react-router';

export const VerifyPhone: React.VFC = () => {
  const me = useCurrentuser();
  const history = useHistory();
  const { search, pathname } = useLocation();

  const params = new URLSearchParams(search);

  const { data, isLoading } = useQuery({
    enabled: me && params.has('sms_verify'),
    queryKey: [ 'user-contacts', ContactName.mobile, me?.id ],
    queryFn: async () => {
      const response = await getUserContacts(me?.id);
      const mobile = response.data.find(c => c.name === ContactName.mobile);

      if (mobile.name === 'email') {
        return null;
      }

      return mobile;
    }
  });

  const handleClose = () => {
    history.push(pathname);
  };

  if (!params.has('sms_verify')) {
    return null;
  }

  if (isLoading) {
    return null;
  }

  if (data.verified) {
    params.delete('sms_verify');
    return null;
  }

  return (
    <PhoneVerificationModal
      open
      onClose={handleClose}
      userId={me.id}
      phone={data.value}
      contactId={data.id}
      contactName={data.name}
    />
  );
};
